export const GET_ZONES = 'GET_ZONES';
